import { Component, Input } from '@angular/core'

export type MgBtnSize = 'medium' | 'small' | 'small-shrink'

@Component({
  selector: 'mg-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false
})
export class ButtonComponent {
  @Input() variant:
    | 'primary'
    | 'primary-invert'
    | 'secondary'
    | 'accent'
    | 'error'
    | 'ghost'
    | 'ghost-invert' = 'primary'
  @Input() size: MgBtnSize = 'small'
  @Input() type: 'button' | 'menu' | 'reset' | 'submit' = 'button'
  @Input() disabled = false
  @Input() loading = false
  @Input() iconType: 'iconPath' | 'svgIcon' = 'svgIcon'
  @Input() icon?: string
  @Input() iconPosition: 'left' | 'right' = 'left'
  @Input() iconContainerClass = ''
  @Input() iconClass = '!text-sm'
  @Input() extraBtnClass = ''
  @Input() lowerCase = true
}
